<div class="d-none d-lg-block">
  <fgb-banner title="{{ 'rewards.nav.lotto' | translate }}" class="mb-3"></fgb-banner>

  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container my-5" *ngIf="lottoItem">
  <div [innerHTML]="lottoItem.TermsAndConditions"></div>
</div>
